import React from "react";
import DatosDemograficos from '../../../containers/DatosDemograficos'
import { CAMPAIGN_2026 } from '../../../constants';

const EvacuadosPorProvincia = () => {
  return <DatosDemograficos campaign={CAMPAIGN_2026} year={2026}/>
};

export default EvacuadosPorProvincia;
